module.exports = __webpack_public_path__ + "static/img/5.f098be9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/5.jpg
// module id = TUEz
// module chunks = 1